import { html, TemplateResult } from "lit-html";
import { ifDefined } from "lit-html/directives/if-defined"

const LinkComponent = ({
  href,
  target,
  cssClasses,
  linkText = ''
}: ILinkElement): TemplateResult => {
  return html`
    <a
      class=${ifDefined(cssClasses)}
      href=${href}
      target=${target}
    >
    ${linkText}
    </a>
  `;
}

export default LinkComponent;